<template>
<div>
    <div class="row">
        <div class="col-12">
            <div class="form-container mb-3">
                <div class="form-title">Consulta</div>

                <div class="row">
                    <div class="col-2">
                        <div class="form-group">
                            <label for="tipo_pessoa" class="mt-1"><strong>Tipo Pessoa:</strong></label>
                            <select class="form-control custom-select-sm custom-dropdown" v-model="tipo_pessoa" @change="VerificaDoc();">
                                <option :value="'PF'" selected>Pessoa Física</option>
                                <option :value="'PJ'">Pessoa Jurídica</option>
                                <option :value="'EN'">Entidade</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-2">
                        <label for="documento" class="mt-1"><strong>{{ label_tipo_documento }}</strong></label>

                        <input v-if="tipo_pessoa == 'PF'"
                               type="text" class="form-control"
                               v-model="documento_pessoa"
                               v-mask="'###.###.###-##'">
                        
                        <input v-else
                               type="text" class="form-control"
                               :value="documento_pessoa"
                               @input="aplicarMascaraCnpj($event)"
                               maxlength="18">
                    </div>
                    <div class="col-2">
                        <input type="checkbox"  v-model="cb_sem_cpf" />&nbsp;<strong>Sem CPF:</strong>
                        <select class="form-control custom-select-sm custom-dropdown" v-model="sem_cpf_motivo" :disabled="!cb_sem_cpf">
                            <option :value="''" selected disabled></option>
                            <option :value="'estrangeiro'">Estrangeiro sem CPF</option>
                            <option :value="'indigente'">Indigente</option>
                            <option :value="'menor18'">Menor de idade</option>
                            <option :value="'precatoria'">Precatória</option>
                            <option :value="'preso'">Preso</option>
                        </select>
                    </div>
                    <div class="col-4">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="outros_documento" class="mt-1"><strong>Outros documentos:</strong></label>
                                <select class="form-control custom-select-sm custom-dropdown" v-model="outro_documento_selecionado">
                                    <option :value="''" selected disabled>Escolha o Tipo:</option>
                                    <option :value="'certidao_nascimento'">Certidão de Nascimento</option>
                                    <option :value="'passaporte'">Passaporte</option>
                                    <option :value="'numero_ordem'">Número da Ordem</option>
                                    <option :value="'titulo_eleitor'">Título de eleitor</option>
                                    <option :value="'inscricao_estadual'">Inscrição Estadual</option>
                                    <option :value="'inscricao_municipal'">Inscrição Municipal</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="outros_documento" class="mt-1"><strong>&nbsp;</strong></label>
                                <input type="text" class="form-control" v-model="documento_pessoa_outro">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label for="pesquisar_nome" class="mt-1"><strong>P<u>e</u>squisar pelo nome:</strong></label>
                    </div>
                    <div class="col-10">
                        <input type="text" class="form-control" v-model="pesquisar_nome">
                    </div>
                    <div class="col-2">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="Consultar();" alt="Esta consulta traz os 10 primeiros registros conforme as letras digitadas. Se a pessoa desejada ainda não apareceu, digite mais caracteres.">
                            <label style="color: white; vertical-align: middle; cursor: pointer;">
                                Consultar
                            </label>
                        </button>
                    </div>
                </div>
                <div class="row" v-if="nomes_resultado.length > 0">
                    <div class="col-12 mt-3">
                        <strong>Resultado(s) da busca:</strong>
                        <div class="card-body mb-2">
                            <p style="text-align: right;">Partes localizadas {{ nomes_resultado.length }}.<br />
                            <span style="text-align: right; font-size: x-small;" v-if="nomes_resultado.length == 10">Exibição máxima de 10 nomes. Se ainda não encontrou a pessoa desejada, digite mais carateres.</span></p>
                            <table class="table table-striped table-bordered mt-2 border">
                                <thead>
                                    <tr class="text-center">
                                        <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                        <th scope="col" style="background-color: lightgrey;">Pessoa</th>
                                        <th scope="col" style="background-color: lightgrey;">CPF / CNPJ</th>
                                        <th scope="col" style="background-color: lightgrey;">Nome / Razão Social</th>
                                        <th scope="col" style="background-color: lightgrey;">Informações Extras</th>
                                        <th scope="col" style="background-color: lightgrey;">Qualificação</th>
                                        <th scope="col" style="background-color: lightgrey;">Principal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="pessoa in nomes_resultado">
                                        <td style="text-align: left; display: none;">{{ pessoa.id }}</td>
                                        <td style="text-align: left;">{{ pessoa.pessoa_tipo == 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica' }}</td>
                                        <td style="text-align: left;">{{ pessoa.cpf_cnpj }}</td>
                                        <td style="text-align: left;">{{ pessoa.nome }}</td>
                                        <td style="text-align: left; font-size: small;">Data Nascim: {{ pessoa.data_nascimento }} - Mãe: {{ pessoa.nome_mae }}</td>
                                        <td style="text-align: left;">
                                            <select class="form-control form-control-sm custom-select-sm custom-dropdown" style="max-width: 300px; margin-left: 10px;" v-model="pessoa.selecaoPolo">
                                                <option :value="'autor'" selected disabled v-if="polo == 1">AUTOR</option>
                                                <option :value="'reu'" disabled v-else-if="polo == 2">REU</option>
                                            </select>
                                        </td>
                                        <td style="text-align: left;">
                                            <select class="form-control form-control-sm custom-select-sm custom-dropdown" style="max-width: 300px; margin-left: 10px;" v-model="pessoa.principal">
                                                <option :value="'1'" selected>Sim</option>
                                                <option :value="'0'">Não</option>
                                            </select>
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="IncluirParte(pessoa.id)">
                                                <label style="color: white; vertical-align: middle; cursor: pointer;">Incluir</label>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="row" v-if="polo==1">
        <div class="col-12">
            <div class="form-container mb-3">
                <div class="form-title">Partes (<u>autores</u>) a utilizar neste ajuizamento</div>
                    <div class="card-body mb-2">
                        <table class="table table-striped table-bordered mt-2 border">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                    <th scope="col" style="background-color: lightgrey;">Nome</th>
                                    <th scope="col" style="background-color: lightgrey;">CPF / CNPJ</th>
                                    <th scope="col" style="background-color: lightgrey;">Tipo de Parte</th>
                                    <th scope="col" style="background-color: lightgrey;">Principal?</th>
                                    <th scope="col" style="background-color: lightgrey;">Tipo Representação</th>
                                    <th scope="col" style="background-color: lightgrey;">Justiça Gratuita</th>
                                    <th scope="col" style="background-color: lightgrey;">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="parte in $store.state.processo.polo_ativo">
                                    <td style="display: none;">{{ parte.id }}</td>
                                    <td style="text-align: left;">{{ parte.nome }}</td>
                                    <td style="text-align: left;">{{ parte.cpf_cnpj }}</td>
                                    <td style="text-align: left;">{{ parte.selecaoPolo == 'autor' ? 'AUTOR' : 'REU' }}</td>
                                    <td style="text-align: center;">{{ parte.principal == 1 ? 'Sim' : 'Não' }}</td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 85px; cursor: pointer; background-color: white;">
                                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Definir</label>
                                        </button>
                                        <br />(Opcional)
                                    </td>
                                    <td style="text-align: center;">
                                        <select class="form-control form-control-sm custom-select-sm custom-dropdown" style="max-width: 300px; margin-left: 10px;" v-model="parte.requer_justica_gratuita">
                                            <option :value="'1'" selected>Requer</option>
                                            <option :value="'0'">Não Requer</option>
                                        </select>
                                    </td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerParte(parte.id)">
                                            <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <hr />
                        <a href="#" @click.prevent="toggleTotalizador">Ver totalizador de partes</a>
                        <table class="table table-striped table-bordered mt-2 border" v-if="totalizadores_visiveis">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey;">Descrição</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes Pincipais</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes Entidades</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>AUTOR</td>
                                    <td>{{ poloAtivoTotal }}</td>
                                    <td>{{ poloAtivoPrincipalTotal }}</td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td>RÉU</td>
                                    <td>{{ poloPassivoTotal }}</td>
                                    <td>{{ poloPassivoPrincipalTotal }}</td>
                                    <td>0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
        </div>
    </div>

    <div class="row" v-if="polo==2">
        <div class="col-12">
            <div class="form-container mb-3">
                <div class="form-title">Partes (<u>rés</u>) a utilizar neste ajuizamento</div>
                    <div class="card-body mb-2">
                        <table class="table table-striped table-bordered mt-2 border">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                    <th scope="col" style="background-color: lightgrey;">Nome</th>
                                    <th scope="col" style="background-color: lightgrey;">CPF / CNPJ</th>
                                    <th scope="col" style="background-color: lightgrey;">Tipo de Parte</th>
                                    <th scope="col" style="background-color: lightgrey;">Principal?</th>
                                    <th scope="col" style="background-color: lightgrey;">Tipo Representação</th>
                                    <th scope="col" style="background-color: lightgrey;">Justiça Gratuita</th>
                                    <th scope="col" style="background-color: lightgrey;">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="parte in $store.state.processo.polo_passivo">
                                    <td style="display: none;">{{ parte.id }}</td>
                                    <td style="text-align: left;">{{ parte.nome }}</td>
                                    <td style="text-align: left;">{{ parte.cpf_cnpj }}</td>
                                    <td style="text-align: left;">{{ parte.selecaoPolo == 'autor' ? 'AUTOR' : 'REU' }}</td>
                                    <td style="text-align: center;">{{ parte.principal == 1 ? 'Sim' : 'Não' }}</td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 85px; cursor: pointer; background-color: white;">
                                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Definir</label>
                                        </button>
                                        <br />(Opcional)
                                    </td>
                                    <td style="text-align: center;">
                                        <select class="form-control form-control-sm custom-select-sm custom-dropdown" style="max-width: 300px; margin-left: 10px;" v-model="parte.requer_justica_gratuita">
                                            <option :value="'1'" selected>Requer</option>
                                            <option :value="'0'">Não Requer</option>
                                        </select>
                                    </td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerParte(parte.id)">
                                            <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <hr />
                        <a href="#" @click.prevent="toggleTotalizador">Ver totalizador de partes</a>
                        <table class="table table-striped table-bordered mt-2 border" v-if="totalizadores_visiveis">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey;">Descrição</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes Pincipais</th>
                                    <th scope="col" style="background-color: lightgrey;">Nº de Partes Entidades</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>AUTOR</td>
                                    <td>{{ poloAtivoTotal }}</td>
                                    <td>{{ poloAtivoPrincipalTotal }}</td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td>RÉU</td>
                                    <td>{{ poloPassivoTotal }}</td>
                                    <td>{{ poloPassivoPrincipalTotal }}</td>
                                    <td>0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
        </div>
    </div>

    <p>
        <strong>Custas Processuais:</strong><br />
        <span style="color: red;">Não há registro de guias geradas para este processo</span>
    </p>

    <div class="row" v-if="polo == 1">
        <div class="col-12">
            <div class="form-container mb-3">
                <div class="form-title" style="font-size: smaller;">
                    Adicionar advogado(s) colaboradores *
                </div>
                <div v-if="isDistribuicaoLote" class="card-subtitulo mt-2" style="font-size: x-small; color: gray;">
                    Neste trecho é adicionado os advogados (alunos) e também podem ser adicionados no último passo desta tela.
                </div>
                <div v-else class="card-subtitulo mt-2" style="font-size: x-small; color: gray;">
                    Este trecho de adição dos demais advogados (alunos) é exclusivo do simulador e não consta na plataforma oficial.
                </div>
                <div class="card-body mb-2" style="font-size: smaller;">
                    <div class="row">
                        <div class="col-6">
                            <label style="font-size: smaller;">Enviar para (alunos):</label>
                            <div class="pos-sugestoes">
                                <input type="text" v-model="campo_busca_aluno_adv_colaborador" @input="buscaAlunosAdvogados('colaboradores')" placeholder="Digite o nome do advogado" class="form-control" />
                                <ul v-if="alunos_adv_encontrados_colaborador.length" class="list-group lista-sugestoes">
                                    <li v-for="result in alunos_adv_encontrados_colaborador" :key="result.id" class="list-group-item" @click="adicionar_adv(result, 'colaboradores')" style="cursor: pointer;">
                                        {{ result.name }}
                                    </li>
                                </ul>
                                <div v-if="colaboradores_selecionados.length" class="mt-2">
                                    <span v-for="colaborador in colaboradores_selecionados" :key="colaborador.id" :style="badgeStyle">
                                        {{ colaborador.name }} <span @click="remover_adv(colaborador, 'colaboradores')" style="cursor: pointer;">&times;</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <label style="font-size: smaller;">Enviar para (grupos):</label>
                            <div class="pos-sugestoes">
                                <input type="text" v-model="campo_busca_grupo" @input="buscaGrupos('colaboradores')" placeholder="Digite o nome do grupo" class="form-control" />
                                <ul v-if="grupos_encontrados.length" class="list-group lista-sugestoes">
                                    <li v-for="grupo in grupos_encontrados" :key="grupo.id" class="list-group-item" @click="adicionarGrupo(grupo, 'colaboradores')" style="cursor: pointer;">
                                        <div>
                                            <strong>{{ grupo.descricao }}</strong><br />
                                            <small>Membros: {{ grupo.users.map(member => member.name).join(', ') }}</small>
                                        </div>
                                    </li>
                                </ul>
                                <div v-if="grupos_selecionados.length" class="mt-2">
                                    <span v-for="grupo in grupos_selecionados" :key="grupo.id" :style="badgeStyle">
                                        {{ grupo.descricao }} <span @click="removerGrupo(grupo, 'colaboradores')" style="cursor: pointer;">&times;</span>
                                    </span>
                                </div>
                            </div>








                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="row" v-if="polo == 2">
        <div class="col-12">
            <div class="form-container mb-3">
                <div class="form-title" style="font-size: smaller;">
                    Adicionar advogado(s) do(s) ré(s) *
                </div>
                <div v-if="isDistribuicaoLote" class="card-subtitulo mt-2" style="font-size: x-small; color: gray;">
                    Neste trecho é adicionado os advogados (alunos) e também podem ser adicionados no último passo desta tela.
                </div>
                <div v-else class="card-subtitulo mt-2" style="font-size: x-small; color: gray;">
                    Este trecho de adição dos demais advogados (alunos) é exclusivo do simulador e não consta na plataforma oficial.
                </div>
                <div class="card-body mb-2" style="font-size: smaller;">
                        <div class="row">
                            <div class="col-6">
                                <label style="font-size: smaller;">Enviar para (alunos):</label>
                                <div class="pos-sugestoes">
                                    <input type="text" v-model="campo_busca_aluno_adv_reu" @input="buscaAlunosAdvogados('reu')" placeholder="Digite o nome do advogado" class="form-control" />
                                    <ul v-if="alunos_adv_encontrados_reu.length" class="list-group lista-sugestoes">
                                        <li v-for="result in alunos_adv_encontrados_reu" :key="result.id" class="list-group-item" @click="adicionar_adv(result, 'reu')" style="cursor: pointer;">
                                            {{ result.name }}
                                        </li>
                                    </ul>
                                    <div v-if="colaboradores_selecionados_reus.length" class="mt-2">
                                        <span v-for="colaborador in colaboradores_selecionados_reus" :key="colaborador.id" :style="badgeStyle">
                                            {{ colaborador.name }} <span @click="remover_adv(colaborador, 'reu')" style="cursor: pointer;">&times;</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <label style="font-size: smaller;">Enviar para (grupos):</label>
                                <div class="pos-sugestoes">
                                    <input type="text" v-model="campo_busca_grupo_reu" @input="buscaGrupos('reu')" placeholder="Digite o nome do grupo" class="form-control" />
                                    <ul v-if="grupos_encontrados_reu.length" class="list-group lista-sugestoes">
                                        <li v-for="grupo in grupos_encontrados_reu" :key="grupo.id" class="list-group-item" @click="adicionarGrupo(grupo, 'reu')" style="cursor: pointer;">
                                            <div>
                                                <strong>{{ grupo.descricao }}</strong><br />
                                                <small>Membros: {{ grupo.users.map(member => member.name).join(', ') }}</small>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="grupos_selecionados_reu.length" class="mt-2">
                                        <span v-for="grupo in grupos_selecionados_reu" :key="grupo.id" :style="badgeStyle">
                                            {{ grupo.descricao }} <span @click="removerGrupo(grupo, 'reu')" style="cursor: pointer;">&times;</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>





</div>
</template>
  
  <script>
  
export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            /* Variaveis dos filtros da consulta de parte */
            tipo_pessoa: 'PF',
            label_tipo_documento: 'CPF:',
            documento_pessoa: '',
            sem_cpf_motivo: '',
            cb_sem_cpf: false,
            outro_documento_selecionado: '',
            documento_pessoa_outro: '',
            pesquisar_nome: '',
            nomes_resultado: [],
            /* Fim das variaveis dos filtros da consulta de parte */
            
            dados_parte_cadastrar:{},

            partes: {
                polo_ativo: [],
                polo_passivo: [],
            },
            
            totalizadores_visiveis: true,

            badgeStyle: {
                display: 'inline-block',
                padding: '0.25em 0.4em',
                fontSize: '75%',
                fontWeight: '700',
                lineHeight: '1',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                verticalAlign: 'baseline',
                borderRadius: '0.375rem',
                color: '#fff',
                backgroundColor: '#6c757d'
            },


            campo_busca_aluno_adv_colaborador: '',
            alunos_adv_encontrados_colaborador: [], 
            colaboradores_selecionados: [],
            campo_busca_aluno_adv_reu: '',
            alunos_adv_encontrados_reu: [], 
            colaboradores_selecionados_reus: [],

            campo_busca_grupo : '',
            grupos_encontrados: [],
            colaboradores_selecionados: [],
            grupos_selecionados: [],

            campo_busca_grupo_reu : '',
            grupos_encontrados_reu: [],
            colaboradores_selecionados_reu: [],
            grupos_selecionados_reu: [],

        };
    },
    props: {
        polo: Number, /* Se polo = 1 é polo ativo (autores), se polo = 2 é polo passivo (reus) */
    },
    methods: {

        toggleTotalizador() {
            this.totalizadores_visiveis = !this.totalizadores_visiveis;
        },
        VerificaDoc(){
            // Ao trocar o tipo de pessoa, limpa o campo documento
            this.documento_pessoa = '';
            if(this.tipo_pessoa=='PF') this.label_tipo_documento = "CPF:";
                else this.label_tipo_documento = "CNPJ:";
        },
        aplicarMascaraCnpj(event) {
            // Remove não-alfanuméricos e converte para maiúsculas
            let input = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
            // Posições 1-12: qualquer alfanumérico
            let corpo = input.substring(0, 12);
            // Posições 13-14 (DV): somente dígitos
            let dv = input.substring(12).replace(/[^0-9]/g, '').substring(0, 2);
            let raw = corpo + dv;
            // Aplica máscara: AA.AAA.AAA/AAAA-##
            let masked = '';
            for (let i = 0; i < raw.length; i++) {
                if (i === 2 || i === 5) masked += '.';
                else if (i === 8) masked += '/';
                else if (i === 12) masked += '-';
                masked += raw[i];
            }
            this.documento_pessoa = masked;
            event.target.value = masked;
        },
        Consultar(){
            if(this.pesquisar_nome == '' && this.documento_pessoa == '' && this.outro_documento_selecionado == ''){
                alert('Preencha uma das formas de pesquisa.');
                return;
            }

            if(this.pesquisar_nome != ''){
                if(this.pesquisar_nome.length < 3){
                    alert('Digite no mínimo 3 caracteres para efetivar a pesquisa.');
                    return;
                }
            }

            this.dados_parte_cadastrar = {
                tipo_pessoa: this.tipo_pessoa,
                label_tipo_documento: this.label_tipo_documento,
                documento_pessoa: this.documento_pessoa,
                sem_cpf_motivo: this.sem_cpf_motivo,
                cb_sem_cpf: this.cb_sem_cpf,
                outro_documento_selecionado: this.outro_documento_selecionado,
                documento_pessoa_outro: this.documento_pessoa_outro,
                pesquisar_nome: this.pesquisar_nome,
                polo: this.polo,
            }

            axios.get(this.BASE_URL + 'parte/buscar_varios', {
                    params: {
                        documento_pessoa: this.dados_parte_cadastrar.documento_pessoa,
                        pesquisar_nome: this.dados_parte_cadastrar.pesquisar_nome,
                        documento_pessoa_outro: this.dados_parte_cadastrar.documento_pessoa_outro,
                    }
                })
                .then(response => {
                    const partes = response.data.partes;
                    if(partes.length>0){
                        this.nomes_resultado = partes;
                        this.nomes_resultado.forEach(pessoa => {
                            pessoa.selecaoPolo = this.polo == 1 ? 'autor' : 'reu';
                            pessoa.principal = 0;
                            pessoa.requer_justica_gratuita = 0;
                        });
                    }
                    else{ //Se a pesquisa não retorna nenhum resultado, vai pra tela de cadastro de partes
                        this.$store.commit('toggleCadastroParteVisivel', this.dados_parte_cadastrar);
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar usuários:", error);
                });
        },
        IncluirParte(pessoaId){
            // Encontra o objeto em this.nomes_resultado que tem o mesmo id que pessoaId
            const pessoaObjeto = this.nomes_resultado.find(pessoa => pessoa.id === pessoaId);

            if (!pessoaObjeto) {
                console.error('Pessoa não encontrada.');
                return;
            }

            // Verifica se a pessoa já está no polo oposto
            let poloOposto;
            if (this.polo == 1) {
                poloOposto = this.$store.state.processo.polo_passivo?.find(parte => parte.id === pessoaObjeto.id);
            } else if (this.polo == 2) {
                poloOposto = this.$store.state.processo.polo_ativo?.find(parte => parte.id === pessoaObjeto.id);
            }

            // Se a pessoa já está no polo oposto, mostra uma mensagem de erro e retorna
            if (poloOposto) {
                alert('Parte não pode ser inserida, pois está incluída como polo oposto.');
                return;
            }


            // Continua com a lógica de adicionar no polo ativo ou passivo
            if (this.polo == 1) {
                const jaExiste = this.$store.state.processo.polo_ativo?.find(parte => parte.id === pessoaObjeto.id);
                if (!jaExiste) {
                    this.$store.commit('setProcessoPoloAtivo', pessoaObjeto);
                }
            } else if (this.polo == 2) {
                const jaExiste = this.$store.state.processo.polo_passivo?.find(parte => parte.id === pessoaObjeto.id);
                if (!jaExiste) {
                    this.$store.commit('setProcessoPoloPassivo', pessoaObjeto);
                }
            }
        },
        removerParte(parteId) {
            this.$store.commit('removePartePolo', parteId);
        },
        sincronizarComBancoDeDados(pessoa, polo) {
            const poloAtivo = this.$store.state.processo.polo_ativo;
            const poloPassivo = this.$store.state.processo.polo_passivo;
            const processoId = this.$store.state.processo.id;

            axios.post(this.BASE_URL + 'sincronizar_partes_processo', { poloAtivo, poloPassivo, processoId })
                .then(response => {

                })
                .catch(error => {
                    console.error("Erro ao sincronizar polos:", error);
                });
        },
        buscaAlunosAdvogados(tipo_adv) {
            
            //Efetiva a buscar só a partir do terceiro caractere digitado no campo
            if (tipo_adv == 'colaboradores')
            {
                if (this.campo_busca_aluno_adv_colaborador.length < 3) {
                    this.alunos_adv_encontrados_colaborador = [];
                    return;
                }
            }
            else{
                if (this.campo_busca_aluno_adv_reu.length < 3) {
                    this.alunos_adv_encontrados_reu = [];
                    return;
                }
            }
            
            let busca = (tipo_adv == 'colaboradores') ? this.campo_busca_aluno_adv_colaborador : this.campo_busca_aluno_adv_reu;

            axios.get(this.BASE_URL + "usuarios/buscar", { params: { query: busca }} )
                .then(response => {
                    if(tipo_adv == 'colaboradores')
                        this.alunos_adv_encontrados_colaborador = response.data;
                    else this.alunos_adv_encontrados_reu = response.data;
                })
                .catch(error => {
                    console.error('Error fetching results:', error);
                    this.results = [];
                });
        },

        adicionar_adv(adv_adicionado, tipo_adv) {
            
            if(tipo_adv == 'colaboradores'){
                if (!this.colaboradores_selecionados.some(c => c.id === adv_adicionado.id)) {
                    this.colaboradores_selecionados.push(adv_adicionado);
                }

                this.campo_busca_aluno_adv_colaborador = '';
                this.alunos_adv_encontrados_colaborador = [];

                this.atualizarAdvogadosNoBackend(tipo_adv);
                this.$store.commit('atualizarAdvogados', { advogados: this.colaboradores_selecionados, tipoAdv: tipo_adv });
            }
            else{
                if (!this.colaboradores_selecionados_reus.some(c => c.id === adv_adicionado.id)) {
                    this.colaboradores_selecionados_reus.push(adv_adicionado);
                }
                this.campo_busca_aluno_adv_reu = '';
                this.alunos_adv_encontrados_reu = [];

                this.atualizarAdvogadosNoBackend(tipo_adv);
                this.$store.commit('atualizarAdvogados', { advogados: this.colaboradores_selecionados_reus, tipoAdv: tipo_adv });
            }

            
        },
        remover_adv(adv_adicionado, tipo_adv) {
            if(tipo_adv == 'colaboradores'){
                this.colaboradores_selecionados = this.colaboradores_selecionados.filter(c => c.id !== adv_adicionado.id);
                this.atualizarAdvogadosNoBackend(tipo_adv);
                this.$store.commit('atualizarAdvogados', { advogados: this.colaboradores_selecionados, tipoAdv: tipo_adv });

            }
            else {
                this.colaboradores_selecionados_reus = this.colaboradores_selecionados_reus.filter(c => c.id !== adv_adicionado.id);
                this.atualizarAdvogadosNoBackend(tipo_adv);
                this.$store.commit('atualizarAdvogados', { advogados: this.colaboradores_selecionados_reus, tipoAdv: tipo_adv });

            }
            
        },
        atualizarAdvogadosNoBackend(tipo_adv) {
            let url = this.BASE_URL + "processo/atualizar_advogados";
            let advogados_enviar = [];
            if(tipo_adv == 'colaboradores'){
                advogados_enviar = this.colaboradores_selecionados;
            }
            else{
                advogados_enviar = this.colaboradores_selecionados_reus;
            }


            axios.post(url, {
                advogados: advogados_enviar,
                tipo_adv: tipo_adv,
                processo_id: this.$store.state.processo.id,
            })
            .then(response => {
            })
            .catch(error => {
                console.error('Error updating advogados in backend:', error);
            });
        },
        
        buscaGrupos(tipo_adv) {

            let busca = '';

            if (tipo_adv == 'colaboradores'){
                if (this.campo_busca_grupo.length < 3) {
                    this.grupos_encontrados = [];
                    return;
                }
                busca = this.campo_busca_grupo;
            }
            else{
                if (this.campo_busca_grupo_reu.length < 3) {
                    this.grupos_encontrados_reu = [];
                    return;
                }

                busca = this.campo_busca_grupo_reu;
            }

            axios.get(this.BASE_URL + "buscar_grupos", { params: { filtro: busca } })
                .then(response => {

                    if (tipo_adv == 'colaboradores'){
                        this.grupos_encontrados = response.data;
                    }
                    else{
                        this.grupos_encontrados_reu = response.data;
                        
                    }

                })
                .catch(error => {
                    console.error('Error fetching groups:', error);
                    this.grupos_encontrados = [];
                });
        },
        adicionarGrupo(grupo, tipo_adv) {
            if (tipo_adv == 'colaboradores'){
                if (!this.grupos_selecionados.some(g => g.id === grupo.id)) {
                    this.grupos_selecionados.push(grupo);
                    //this.atualizarGruposNoBackend();
                    //this.$store.commit('atualizarGrupos', this.grupos_selecionados);
                    grupo.users.forEach(member => {
                        this.adicionar_adv(member, 'colaboradores');
                    });

                }
                this.campo_busca_grupo = '';
                this.grupos_encontrados = [];
            }
            else{
                if (!this.grupos_selecionados_reu.some(g => g.id === grupo.id)) {
                    this.grupos_selecionados_reu.push(grupo);
                    //this.atualizarGruposNoBackend();
                    //this.$store.commit('atualizarGrupos', this.grupos_selecionados_reu);
                    grupo.users.forEach(member => {
                        this.adicionar_adv(member, 'reu');
                    });
                }
                this.campo_busca_grupo_reu = '';
                this.grupos_encontrados_reu = [];
            }

        },
        removerGrupo(grupo, tipo_adv) {
            if (tipo_adv == 'colaboradores'){
                this.grupos_selecionados = this.grupos_selecionados.filter(g => g.id !== grupo.id);
                //this.atualizarGruposNoBackend();
                //this.$store.commit('atualizarGrupos', this.grupos_selecionados);
                grupo.users.forEach(member => {
                        this.remover_adv(member, 'colaboradores');
                    });
            }
            else{
                this.grupos_selecionados_reu = this.grupos_selecionados_reu.filter(g => g.id !== grupo.id);
                //this.atualizarGruposNoBackend();
                //this.$store.commit('atualizarGrupos', this.grupos_selecionados_reu);
                grupo.users.forEach(member => {
                        this.remover_adv(member, 'reu');
                    });
            }
        },

       
        
    },
    mounted() {
        this.dados_parte_cadastrar = this.$store.state.cadastro_parte_dados;


        if(this.$store.state.processo.advogados_colaboradores) this.colaboradores_selecionados = this.$store.state.processo.advogados_colaboradores;
        if(this.$store.state.processo.advogados_reus) this.colaboradores_selecionados_reus = this.$store.state.processo.advogados_reus;

    },
    computed: {

        poloPassivoTotal() {
            if (!this.$store.state.processo.polo_passivo || this.$store.state.processo.polo_passivo.length === 0) {
                return 0;
            }
            return this.$store.state.processo.polo_passivo.length;
        },
        poloPassivoPrincipalTotal() {
            if (!this.$store.state.processo.polo_passivo || this.$store.state.processo.polo_passivo.length === 0) {
                return 0;
            }
            
            return this.$store.state.processo.polo_passivo.filter(parte => parte.principal == 1).length;
        },

        poloAtivoTotal() {
            if (!this.$store.state.processo.polo_ativo || this.$store.state.processo.polo_ativo.length === 0) {
                return 0;
            }
            return this.$store.state.processo.polo_ativo.length;
        },
        poloAtivoPrincipalTotal() {
            if (!this.$store.state.processo.polo_ativo || this.$store.state.processo.polo_ativo.length === 0) {
                return 0;
            }
            
            return this.$store.state.processo.polo_ativo.filter(parte => parte.principal == 1).length;
        },

        isDistribuicaoLote() {
            // Verifica se a URL atual contém o trecho "distribuicao_lote"
            return window.location.href.includes('distribuicao_lote');
        },
    },
    watch: {
        '$store.state.processo.polo_ativo': {
            handler(newValue, oldValue) {
                this.sincronizarComBancoDeDados(newValue, 'ativo');
            },
            deep: true
        },
        '$store.state.processo.polo_passivo': {
            handler(newValue, oldValue) {
                this.sincronizarComBancoDeDados(newValue, 'passivo');
            },
            deep: true
        }
    },
};
</script>
  
<style scoped>
.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;
}

.custom-dropdown {
  height: 35px; /* Diminui a altura do campo select */
  position: relative;
  font-size: small;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22292.4%22%20height%3D%22292.4%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20viewBox%3D%220%200%20292.4%20292.4%22%20enable-background%3D%22new%200%200%20292.4%20292.4%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cg%3E%0A%3Cpath%20d%3D%22M287%2069.201a9.7%209.7%200%200%201%201.7%206.813l-4%204%20c-0.092%200.093-0.203%200.166-0.3%200.26l-127%20127c-1.8%201.801-4.501%202.701-7.1%202.701s-5.3-0.9-7.1-2.7l-127-127c-0.1-0.094-0.2-0.167-0.3-0.26l-4-4c-1.8-1.801-1.8-4.701%200-6.5%200.9-0.899%202.3-1.5%203.6-1.5h254.8c1.3%200%202.7%200.601%203.6%201.5z%22%20fill%3D%22%23000000%22/%3E%0A%3C/g%3E%0A%3C/svg%3E');
  background-position: right 0.75rem center;
  background-size: 10px 10px;
  background-repeat: no-repeat;
}

/* Estilo para manter o ícone de seta mesmo com o select aberto */
.custom-dropdown:focus {
  background-image: none;
  outline: none;
}

/* Estilo para reverter o ícone de seta padrão */
.custom-dropdown::-ms-expand {
  display: none;
}

table{
    font-size: small;
}

/* Wrapper para ancorar o dropdown */
.pos-sugestoes {
    position: relative;
}

/* A lista vira dropdown suspenso */
.lista-sugestoes {
    position: absolute;
    top: calc(100% + 4px); /* um pouquinho abaixo do input */
    left: 0;
    width: 100%;
    z-index: 1050;         /* acima dos outros elementos do card */
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    padding-top: 0;
    padding-bottom: 0;
}

/* Opcional: refinar visual dos itens (Bootstrap já ajuda) */
.lista-sugestoes .list-group-item {
    border-left: none;
    border-right: none;
}

.lista-sugestoes .list-group-item:last-child {
    border-bottom: none;
}

</style>
  
